import { render, staticRenderFns } from "./FilePermissionPage.vue?vue&type=template&id=18de16cc&scoped=true&"
import script from "./FilePermissionPage.vue?vue&type=script&lang=js&"
export * from "./FilePermissionPage.vue?vue&type=script&lang=js&"
import style0 from "./FilePermissionPage.vue?vue&type=style&index=0&id=18de16cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18de16cc",
  null
  
)

export default component.exports